import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { formatDate, FORMAT_DATE_BACK, getPreviousDate, postSubmit } from "@ui-seeker/utils"

import { DATE_PERIODS, GROUPED_BY, WEBBACK_V2_API } from "@constants"
import { commonFiltersValue, isLoadingCommonFilters, isSystemBusy } from "@signals"
import { elementsInLoading, sellerDeepDiveEndDate, sellerDeepDiveOffersCurrentPeriod, sellerDeepDiveOffersFilters } from "../@signals"


export default function useSellerDeepDiveShareMblData() {
	const dataChart = useSignal([])
	const color = useSignal({})
	const series = useSignal([])
	const isLoading = useSignal(false)
	const selectedGroupedBy = useSignal(GROUPED_BY.GENERAL)

    const newFilters = commonFiltersValue.peek()

    useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			isLoading.value = true
			dataChart.value = []
			postSubmit(`${WEBBACK_V2_API}/marketplaces/seller-deep-dive/share-mbl`, { ...commonFiltersValue.value, groupedBy: selectedGroupedBy.value }).then(res => {
				const [firstElement] = res.data
				if (!firstElement?.actualData?.length){
					dataChart.value = []
				} else {
					dataChart.value = res.data
				}
				
				color.value = res.color
				series.value = res.series
			}).catch(() =>
				isSystemBusy.value = true
			).finally(() => {
				isLoading.value = false
				isLoadingCommonFilters.value = false
			})
		})
	}, [isLoadingCommonFilters.value])

	const handleSelectedGroupedBy = (e) => {
		selectedGroupedBy.value = e.target.value
		isLoading.value = true
		dataChart.value = []
		postSubmit(`${WEBBACK_V2_API}/marketplaces/seller-deep-dive/share-mbl`, { ...commonFiltersValue.value, groupedBy: selectedGroupedBy.value }).then(res => {
			if (!res.data?.length)
				dataChart.value = []
			else
				dataChart.value = res.data
			
			color.value = res.color
			series.value = res.series
		}).catch(() => isSystemBusy.value = true
		).finally(() => {
			isLoading.value = false
		})
	}

	const handleClickShowEvolution = (groupedID = 0) => { batch(() => {
        sellerDeepDiveEndDate.value = newFilters.endDate
        let startDate = formatDate(getPreviousDate({days: 6}, sellerDeepDiveEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

        sellerDeepDiveOffersCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

        sellerDeepDiveOffersFilters.value = {
            ...commonFiltersValue.peek(),
            startDate: startDate,
            endDate: sellerDeepDiveEndDate.value,
			groupedBy: groupedID !== 0 ? selectedGroupedBy.value : GROUPED_BY.GENERAL,
			groupedID: groupedID
        }})
    }

    useEffect(() => {
        if (isLoading.value)
            elementsInLoading.value = [...elementsInLoading.value, 'detailsTable']
        else
            elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'detailsTable')
    }, [isLoading.value])

	return {
		dataChart: dataChart.value,
		color: color.value,
		series: series.value,
		isLoading: isLoading.value,
		selectedGroupedBy: selectedGroupedBy.value,
		handleSelectedGroupedBy,
		handleClickShowEvolution
	}
}